import React, { useEffect, useRef } from 'react'
import { Button, Form } from 'react-bootstrap'

const AddProject = ({ onSubmit, project }) => {
  const projectNameRef = useRef();
  const projectDescriptionRef = useRef();
  const pricePerHourRef = useRef();
  const projectStatusRef = useRef();

  useEffect(() => {
    projectNameRef.current.value = project?.name ?? '';
    projectDescriptionRef.current.value = project?.description ?? '';
    pricePerHourRef.current.value = project?.price ?? '';
    projectStatusRef.current.value = project?.status ?? 'Ongoing';
  }, [project]);

  const handleSubmit = () => {
    const tempProject = {
      id: project?.id,
      name: projectNameRef.current.value,
      description: projectDescriptionRef.current.value,
      price: pricePerHourRef.current.value,
      status: projectStatusRef.current.value,
      elapsed: project?.elapsed,
      runningSince: project?.runningSince
    };

    onSubmit(tempProject);
    projectNameRef.current.value = '';
    projectDescriptionRef.current.value = '';
    pricePerHourRef.current.value = '';
    projectStatusRef.current.value = 'Ongoing';
  }

  return (
    <Form>
        <Form.Group className="mb-3">
          <Form.Label>Project Name</Form.Label>
          <Form.Control
              type="text"
              placeholder="Enter project name"
              ref={projectNameRef}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Project Description</Form.Label>
          <Form.Control
              type="text"
              placeholder="Enter project description"
              ref={projectDescriptionRef}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Price Per Hour</Form.Label>
          <Form.Control
              type="text"
              placeholder="Enter price per hour"
              ref={pricePerHourRef}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Select Status</Form.Label>
          <Form.Select aria-label="Default select example" ref={projectStatusRef}>
            <option value="Ongoing">Ongoing</option>
            <option value="Completed">Completed</option>
          </Form.Select>
        </Form.Group>
        <Button variant="primary" onClick={handleSubmit}>
          Add Project
        </Button>
    </Form>
  )
}

export default AddProject